import {
    ReducerState,
    SearchFormAction,
    SearchFormReducerAction,
} from './types';

export const createInitialState = (): ReducerState => ({
    activeFilterList: [],
});

export const SearchFormReducer = (
    state: ReducerState,
    action: SearchFormReducerAction
): ReducerState => {
    switch (action.type) {
        case SearchFormAction.UpdateActiveFilterList:
            return {
                ...state,
                activeFilterList: action.payload,
            };
        case SearchFormAction.RemoveActiveFilter:
            return {
                ...state,
                activeFilterList: state.activeFilterList.filter(
                    (_, index) => index !== action.payload
                ),
            };
        case SearchFormAction.RemoveAllActiveFilter:
            return {
                ...state,
                activeFilterList: [],
            };
    }
};
